module.exports.lobby = {
  vi: {
    title: 'Avalon online miễn phí | The Resistance: Avalon',
    description:
      'Chơi The Resistance: Avalon online. Ván chơi miễn phí với 5–10 người thật, kèm luật và vai trò. Thử chơi một mình hoặc cùng bạn với bot; điều kiện tùy chế độ bot.',
    keywords: ['Chơi Avalon online'],
  },
  pt: {
    title: 'Avalon online grátis: jogo de tabuleiro com amigos',
    description:
      'Jogue The Resistance: Avalon no navegador. Partidas grátis com 5–10 pessoas, regras e papéis. Experimente bots sozinho ou com amigos; o acesso varia por modo.',
    keywords: ['Jogar'],
  },
  en: {
    title: 'Avalon Online Free | The Resistance: Avalon Board Game',
    description:
      'Play The Resistance: Avalon board game online. Free games with 5–10 human players, rules and roles. Try bots solo or with friends; access varies by bot mode.',
    keywords: ['Play'],
  },
  ru: {
    title: 'Авалон онлайн — играть бесплатно с друзьями на 5–10 человек',
    description:
      'Играйте в настольный «Авалон» онлайн: бесплатно на 5–10 живых игроков, правила и роли. Есть игра с ботами одному или с друзьями; доступ зависит от режима.',
    keywords: ['Играть'],
  },
  'zh-TW': {
    title: '阿瓦隆線上遊戲｜免費與朋友一起玩',
    description:
      '免費在瀏覽器玩阿瓦隆桌遊，真人局支援 5–10 人。查閱規則與角色，登入建立房間並邀請朋友。也能單人或與朋友對戰機器人；使用條件依模式而異。',
    keywords: ['遊玩'],
  },
  'zh-CN': {
    title: '阿瓦隆在线游戏｜免费桌游、规则与角色',
    description:
      '免费在浏览器玩阿瓦隆桌游，真人局支持 5–10 人。查看规则与角色，登录创建房间并邀请朋友。也能单人或与朋友对战机器人；使用条件因模式而异。',
    keywords: ['玩'],
  },
  es: {
    title: 'Avalon: juego de mesa online gratis con amigos',
    description:
      'Juega al juego de mesa The Resistance: Avalon en el navegador. Partidas gratis con 5–10 personas y modos con bots; el acceso a bots depende del modo.',
    keywords: ['Jugar'],
  },
};
